document.addEventListener("DOMContentLoaded", () => {
	initCustomHref();
});

function initCustomHref() {
	let links = document.querySelectorAll("[data-href]");
	if (!links.length) return;

	links.forEach(el => {
		el.addEventListener("click", e => {
			e.preventDefault();
			window.location.href = el.dataset.href;
		});
	});
}
